import { useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { filtrarIngresosEgresos, filtrarVentasMedicos, filtrarVentasDiarias, filtrarVentasDetalle, filtrarVentasUnidades, filtrarLineasVenta, filtrarOrdenesItems } from '../../actions/reportes';

import FiltrosIngresosEgresos from './FiltrosIngresosEgresos';
import FiltrosVentasMedicos from './FiltrosVentasMedicos';
import FiltrosVentasDiarias from './FiltrosVentasDiarias';
import FiltrosVentasDetalle from './FiltrosVentasDetalle';
import FiltrosVentasUnidades from './FiltrosVentasUnidades';
import FiltrosLineasVenta from './FiltrosLineasVenta';
import FiltrosOrdenesItems from './FiltrosOrdenesItems';

const Reportes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Reportes',
            path: '/reportes'
        }
    ];

    const dispatch = useDispatch();

    /* Buscar */
    const handleFiltrosIngresosEgresos = () => {
        dispatch(filtrarIngresosEgresos(true));
    }

    const handleFiltrosVentasMedicos = () => {
        dispatch(filtrarVentasMedicos(true));
    }

    const handleFiltrosVentasDiarias = () => {
        dispatch(filtrarVentasDiarias(true));
    }

    const handleFiltrosVentasDetalle = () => {
        dispatch(filtrarVentasDetalle(true));
    }

    const handleFiltrosVentasUnidades = () => {
        dispatch(filtrarVentasUnidades(true));
    }

    const handleFiltrosLineasVenta = () => {
        dispatch(filtrarLineasVenta(true));
    }

    const handleFiltrosOrdenesItems = () => {
        dispatch(filtrarOrdenesItems(true));
    }

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .titulo {
                            color:rgb(102, 134, 6);
                            margin-top: 20px;
                        }

                        .subtitulo {
                            margin: 0px;
                        }
                        
                        .buttonIcon {
                            padding: 20px;
                            font-size: 30px;
                            background-color: #caec67;
                            color: #000000;
                            border-radius: 10px;
                            margin-bottom: 15px;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <FiltrosIngresosEgresos/>
            <FiltrosVentasMedicos/>
            <FiltrosVentasDiarias/>
            <FiltrosVentasDetalle/>
            <FiltrosVentasUnidades/>
            <FiltrosLineasVenta/>
            <FiltrosOrdenesItems/>

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Reportes</h3>
                </div>

                <div className="col-md-8 offset-md-2">
                    <div className="row mb-3 mt-5">
                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosIngresosEgresos()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-money-bill-transfer" />
                                        <h5 className="titulo">Ingresos y egresos</h5>
                                        <p className="subtitulo">Permite visualizar el listado de ingresos y el listado de egresos, asi como el balance general.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosVentasMedicos()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-dollar-sign" />
                                        <h5 className="titulo">Ventas por médicos</h5>
                                        <p className="subtitulo">Permite visualizar el total de ventas realizadas por cada uno de los médicos existentes.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosVentasDiarias()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-calendar-days" />
                                        <h5 className="titulo">Totalización de ventas diarias</h5>
                                        <p className="subtitulo">Permite visualizar el monto total de las ventas de un día y el detalle de los métodos de pago en el periodo seleccionado.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosVentasDetalle()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-calendar-day" />
                                        <h5 className="titulo">Ventas</h5>
                                        <p className="subtitulo">Permite visualizar el listado de ventas en un periodo determinado.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosVentasUnidades()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-boxes-stacked" />
                                        <h5 className="titulo">Unidades vendidas (Item/SKU)</h5>
                                        <p className="subtitulo">Permite visualizar el detalle de las unidades (Item/SKU) vendidas, así como el método de pago, en el periodo seleccionado.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosLineasVenta()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-list" />
                                        <h5 className="titulo">Detalle de líneas de venta</h5>
                                        <p className="subtitulo">Permite visualizar cada producto y servicio vendido de forma individual, con su fecha, folio, cliente, paciente y médico asociado.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosOrdenesItems()}>
                                <div className="card-body centrado_horizontal">
                                    <div className="mb-0">
                                        <i className="buttonIcon fa-solid fa-truck-ramp-box" />
                                        <h5 className="titulo">Órdenes (Item/SKU)</h5>
                                        <p className="subtitulo">Permite visualizar el detalle de los items (Item/SKU) recibidos en órdenes autorizadas, con su consecutivo, documento y fecha, en el periodo seleccionado.</p>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Reportes;